










































































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';

import SvgImage from '~/components/General/SvgImage.vue';
import ProductTile from '~/components/ProductTile/ProductTile.vue';
import useAttributes from '~/composables/useAttributes';
import { PLP_GROUPS_ORDER } from '~/constants';
import { isGenuine } from '~/helpers/productHelpers';
import { BestValue, ProductInterface } from '~/modules/GraphQL/types';

export default defineComponent({
  components: {
    ProductTile,
    SvgImage,
  },
  props: {
    products: {
      type: Array as PropType<ProductInterface[]>,
      required: true,
    },
    groupName: {
      type: String,
      default: '',
    },
    isParentHp: {
      type: Boolean,
      default: false,
    },
    categoryId: {
      type: [Number, String],
      default: '',
    },
    categoryName: {
      type: String,
      default: '',
    },
    bestValues: {
      type: Array as PropType<BestValue[]>,
      default: () => ([]),
    },
  },
  setup(props) {
    const { attributes: attributeList, getOptionLabel } = useAttributes();

    const groupBy = (array, property) => array.reduce((acc, obj) => {
      const key = obj[property];

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push(obj);

      return acc;
    }, {});
    const sortProducts = (products: ProductInterface[]) => products.sort((current, prev) => {
      if (isGenuine(current) !== isGenuine(prev)) {
        return (props.isParentHp && isGenuine(current))
        || (!props.isParentHp && !isGenuine(current)) ? -1 : 1;
      }

      return Number.parseFloat(prev.per_page_price) > Number.parseFloat(current.per_page_price) ? -1 : 1;
    });
    const getGroupName = (id: String | Number) => getOptionLabel('group', +id);
    const isMaintenance = (name: String) => (name ? getGroupName(name)?.toLowerCase() === 'maintenance items' : false);

    const staticSort = computed(() => {
      const attribute = attributeList.value?.find((attributeData) => attributeData.attribute_code === 'group');
      const sortedAttribute = [];

      if (attribute?.attribute_options) {
        attribute.attribute_options.forEach((option) => {
          if (PLP_GROUPS_ORDER.includes(option.label)) {
            sortedAttribute[PLP_GROUPS_ORDER.indexOf(option.label)] = option.value;
          }
        });
      }

      return sortedAttribute;
    });

    const groupedProducts = computed<object>(() => {
      const preparedProducts = sortProducts(props.products);

      return groupBy(preparedProducts, 'group');
    });

    const sortedProducts = computed(() => {
      if (props.products.length === 0) return [];

      // eslint-disable-next-line unicorn/prefer-native-coercion-functions
      const sortedAttributes = staticSort.value ? staticSort.value.filter((el) => Number(el)) : [];
      const resSortedProducts = {};
      const resGroupedProducts = { ...groupedProducts.value };

      Object.entries(groupedProducts.value).forEach(([key, value]) => {
        resGroupedProducts[key] = groupBy(value, 'manufacturer_anchor');
      });

      sortedAttributes.forEach((attribute) => {
        if (groupedProducts.value[attribute]) {
          resSortedProducts[` ${attribute}`] = resGroupedProducts[attribute];
          delete resGroupedProducts[attribute];
        }
      });

      return { ...resSortedProducts, ...resGroupedProducts };
    });

    const groupSwatches = computed(() => {
      const yields = {};

      Object.keys(groupedProducts.value).forEach((key) => {
        if (key !== 'undefined' && groupedProducts.value[key]) {
          groupedProducts.value[key].forEach((product) => {
            if (isMaintenance(key)) {
              yields[key] = [];
              return;
            }

            if (product.yields?.length) {
              const swatches = product.yields.map((item) => item.swatches).filter(Boolean);

              // eslint-disable-next-line
              yields[key] = [...Array.prototype.concat(...swatches)];
            }
          });
        }
      });

      return yields;
    });

    return {
      sortedProducts,
      groupSwatches,
      isMaintenance,
      getGroupName,
    };
  },
});
